import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FormErrors, ParticipantFormData } from "../../types";
import { InputDatePicker } from "../../../../../components/InputDatePicker";

interface ParticipanFormProps {
    formData: ParticipantFormData;
    errors: FormErrors;
    onChangeInputField: (field: keyof ParticipantFormData) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
    onChangeDataField: (field: keyof ParticipantFormData) => (date: Date | null) => void;
}

export default function ParticipantPersonForm({ formData, errors, onChangeInputField, onChangeDataField }: ParticipanFormProps) {
    const { t } = useTranslation();

    return (
        <>
            <Row style={{ marginTop: '40px' }}>
                <h5>{t("participant:new.headerDemograficData")}</h5>
            </Row>
            <Row style={{ marginTop: '20px' }}>
                
                <Col xs={6} md={6}>
                    <Form.Group>
                        <Form.Label>{t("participant:new.labelAplicationExtern")}</Form.Label>
                        <Form.Control
                            type="text"
                            name="externApplication"
                            value={formData.externApplication}
                            onChange={onChangeInputField('externApplication')}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row style={{ marginTop: '20px' }}>
                <Col xs={4} md={4}>
                    <Form.Group>
                        <Form.Label>{t("participant:new.labelParticipantName")}</Form.Label>
                        <Form.Control
                            type="text"
                            name={formData.nameParticipant}
                            value={formData.nameParticipant}
                            onChange={onChangeInputField('nameParticipant')}
                        />
                    </Form.Group>
                </Col>
                <Col xs={4} md={4}>
                    <Form.Group>
                        <Form.Label>{t("participant:new.labelParticipantSurname")}</Form.Label>
                        <Form.Control
                            type="text"
                            name={formData.surnameParticipant}
                            value={formData.surnameParticipant}
                            onChange={onChangeInputField('surnameParticipant')}
                        />
                    </Form.Group>
                </Col>
                <Col xs={4} md={4}>
                    <Form.Group>
                        <Form.Label>{t("participant:new.labelParticipantSurname2")}</Form.Label>
                        <Form.Control
                            type="text"
                            name={formData.surname2Participant}
                            value={formData.surname2Participant}
                            onChange={onChangeInputField('surname2Participant')}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row style={{ marginTop: '20px' }}>
                <Col xs={4} md={4}>
                    <Form.Group>
                        <Form.Label>{t("participant:new.labelPhone")}</Form.Label>
                        <Form.Control
                            type="text"
                            name={formData.phone}
                            value={formData.phone}
                            onChange={onChangeInputField('phone')}
                            isInvalid={!!errors.phone}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.phone || ""}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col xs={6} md={6}>
                    <Form.Group>
                        <Form.Label>{t("participant:new.labelEmail")}</Form.Label>
                        <Form.Control
                            type="text"
                            name={formData.email}
                            value={formData.email}
                            onChange={onChangeInputField('email')}
                            isInvalid={!!errors.email}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.email || ""}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
            <Row style={{ marginTop: '30px' }}>
                <Col xs={4} md={4}>
                    <InputDatePicker
                        value={formData.birthDateISO}
                        onChange={onChangeDataField('birthDateISO')}
                        label={t("participant:new.labelBirthDate")}
                    />
                </Col>
                <Col xs={6} md={4}>
                    <Form.Group>
                        <Form.Label>{t("participant:new.labelCountryBirth")}</Form.Label>
                        <Form.Control
                            type="text"
                            name={formData.bithCountry}
                            value={formData.bithCountry}
                            onChange={onChangeInputField('bithCountry')}
                        />
                    </Form.Group>
                </Col>
                <Col xs={4} md={4}>
                    <Form.Label>{t("participant:new.labelGender")}</Form.Label>
                    <Form.Select
                        value={formData.gender}
                        onChange={onChangeInputField('gender')}
                    >
                        <option value="" disabled>{t("participant:new.labelInputTextSelect")}</option>
                        <option value="Hombre">{t("participant:new.labelInputTextSelectOptionGenderMale")}</option>
                        <option value="Mujer">{t("participant:new.labelInputTextSelectOptionGenderFemale")}</option>
                        <option value="NoBinario">{t("participant:new.labelInputTextSelectOptionGenderNoBinary")}</option>
                        <option value="NoResponder">{t("participant:new.labelInputTextSelectOptionGenderNotAnswer")}</option>

                    </Form.Select>
                </Col>
            </Row>
            <Row style={{ marginTop: '30px' }}>
                <Col xs={4} md={4}>
                    <Form.Group>
                        <Form.Label>{t("participant:new.labelzipCode")}</Form.Label>
                        <Form.Control
                            type="text"
                            name={formData.zipCode}
                            value={formData.zipCode}
                            onChange={onChangeInputField('zipCode')}
                        />
                    </Form.Group>
                </Col>
                <Col xs={6} md={4}>
                    <Form.Group>
                        <Form.Label>{t("participant:new.labelPoblation")}</Form.Label>
                        <Form.Control
                            type="text"
                            name={formData.city}
                            value={formData.city}
                            onChange={onChangeInputField('city')}
                        />
                    </Form.Group>
                </Col>
                <Col xs={4} md={4}>
                    <Form.Group>
                        <Form.Label>{t("participant:new.labelProvince")}</Form.Label>
                        <Form.Control
                            type="text"
                            name={formData.province}
                            value={formData.province}
                            onChange={onChangeInputField('province')}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row style={{ marginTop: '30px' }}>
                <Col xs={6} md={6}>
                    <Form.Group>
                        <Form.Label>{t("participant:new.labelRegion")}</Form.Label>
                        <Form.Control
                            type="text"
                            name={formData.region}
                            value={formData.region}
                            onChange={onChangeInputField('region')}
                        />
                    </Form.Group>
                </Col>
                <Col xs={6} md={6}>
                    <Form.Group>
                        <Form.Label>{t("participant:new.labelCountry")}</Form.Label>
                        <Form.Control
                            type="text"
                            name={formData.country}
                            value={formData.country}
                            onChange={onChangeInputField('country')}
                        />
                    </Form.Group>
                </Col>
            </Row>
        </>
    );
}